export const selectToPrintHTML = state => state.getIn(['printHTML', 'htmlResult']);
export const selectToSilentPrintHTML = state => state.getIn(['printHTML', 'silentPrintHTMLResult']);
export const selectPrintHTMLLoading = state => state.getIn(['printHTML', 'isLoading']);
export const selectSetPrinterModalState = state =>
  state.getIn(['printHTML', 'setPrinterModalState']);
